export default __webpack_public_path__ + "static/media/Monsoon-Mandu.2387f2d8.jpg";